import {type FunctionalComponent, h} from '@stencil/core';
import type { SearchApiDocumentMySE } from '../../../../../../api/model/response/documents/private/MySEDocument';
import { UiaasSearchLabelList } from '../../../../result-cards/subcomponents/uiaas-search-label-list';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IDashboardQuoteItemProperties {
    doc: SearchApiDocumentMySE;
    labelProvider: labelProviderInterface;
}

export const DashboardCpqQuoteItemLabels: FunctionalComponent<IDashboardQuoteItemProperties> = (props) => {
    const { doc, labelProvider } = props;

    return (
      <span><UiaasSearchLabelList
        list={[
          {
            label: labelProvider('result.seamless.quoteDescription', 'Quote name'),
            value: doc?.quoteDescription,
          },
          {
            value: labelProvider('result.seamless.' + doc.source, 'Quote'),
            customValueClass: 'private__category',
          }
        ]}
      />
      <UiaasSearchLabelList
        list={[
          {
            label: labelProvider('result.seamless.accountId', 'Account ID'),
            value: doc?.accountId
          }
        ]}
      />
      </span>);
};
